import React, { PropsWithChildren, ReactElement } from "react";
import { Box } from "@mui/material";
import { ReactComponent as LoadingLogoOrange } from "../assets/images/loading/LoadingLogoOrange.svg";
import { ReactComponent as LoadingLogoBlue } from "../assets/images/loading/LoadingLogoBlue.svg";

type Props = {
    secondary?: boolean;
    styleProps?: React.CSSProperties;
    zIndex?: number;
    borderLeft?: boolean;
    locale?: string;
};

const Loading = (props: PropsWithChildren<Props>): ReactElement => {
    return (
        <Box
            data-testid="loading"
            height="100vh"
            width="100vw"
            borderLeft={props.borderLeft ? "1px solid #E3E3E3" : "none"}
            sx={{
                bgcolor: props.styleProps?.background ? props.styleProps?.background : "rgba(0, 0, 0, 0.5)",
                position: props.styleProps?.position ? props.styleProps?.position : "fixed",
                top: 0,
                left: 0,
                zIndex: props.zIndex ? props.zIndex : 2000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2
                }}
            >
                <Box
                    height="70px"
                    width="70px"
                    sx={{
                        zIndex: props.zIndex ? props.zIndex : 2001
                    }}
                >
                    {props.secondary ?   <LoadingLogoOrange /> : <LoadingLogoBlue />  }
                </Box>
                {props.children && (
                    <Box
                        sx={{
                            textAlign: "center",
                            zIndex: props.zIndex ? props.zIndex : 2001
                        }}
                    >
                        {props.children}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Loading;
